<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl">
      <icon name="gear" class="w-6 mr-3 fill-gray-700" /> Menu inicial
    </h1>

    <div class="bg-white rounded-md shadow p-7">
      <h2>Seja bem vindo ao SmartDestination</h2>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import axios from 'axios'
import { ptBR } from 'vuejs-datepicker/dist/locale'

export default {
  metaInfo: { title: 'Dashboard' },
  components: {
    Icon,
  },
  layout: Layout,
  props: {},
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style scoped></style>
